.base {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 0;
  border-radius: var(--r-md);
  font-weight: 600;
  cursor: pointer;
  /* Подсветка тапа в мобильном WebView мешает собственному :active. */
  -webkit-tap-highlight-color: transparent;
  transition: transform 0.12s ease, opacity 0.12s ease;
}

.base:active:not(:disabled) {
  transform: scale(0.98);
}

.base:disabled {
  opacity: 0.45;
  cursor: default;
}

.block {
  width: 100%;
}

.m {
  height: 50px;
  padding: 0 20px;
  font-size: 16px;
}

.s {
  height: 38px;
  padding: 0 14px;
  font-size: 14px;
  border-radius: var(--r-sm);
}

/* Главное действие. Один такой на экран — иначе перестаёт значить
   «главное». В тёмной теме это светлая кнопка с тёмным текстом:
   на чёрном выделяет именно светлота. */
.primary,
.onHero {
  background: var(--btn-primary-bg);
  color: var(--btn-primary-fg);
}

.accent {
  background: var(--accent);
  color: var(--btn-primary-fg);
  box-shadow: var(--glow);
}

.quiet {
  background: var(--surface-sunken);
  border: 1px solid var(--card-border);
  color: var(--ink);
}
